import esdImage from '../assets/homeImages/home_images/home_5.png';
import fanImage from '../assets/homeImages/home_images/home_6.png';
import gerImage from '../assets/homeImages/home_images/home_7.png';

export const systemList = [
  {
    id: 0,
    serving: '系统服务',
    array: [
      'OCR识别',
      '工商信息',
      '发票验真',
      '智能中登查询',
      '一键电子签约',
      '预设对外接口',
    ],
    img: esdImage,
  },
  {
    id: 1,
    serving: '运营服务',
    array: [
      '客服支持',
      '资产收集',
      '单证审核',
      '数据跟踪',
      '方案设计',
      'IT支持',
    ],
    img: fanImage,
  },
  {
    id: 2,
    serving: '定制服务',
    array: ['专项模块定制化', '风控逻辑定制', '业务流程定制', '审批流程定制'],
    img: gerImage,
  },
];

export const qualificationsList = [
  {
    id: 1,
    year: '2022',
    word: '高新技术企业',
    position: '',
  },
  {
    id: 2,
    year: '2023',
    word: '天津移动生态',
    position: '合作伙伴',
  },
  {
    id: 3,
    year: '2021',
    word: '天津商业',
    position: '副会长单位',
  },
  {
    id: 4,
    year: '2023',
    word: '天津软件协会',
    position: '会员',
  },
  {
    id: 5,
    year: '2021',
    word: '实用新型专利',
    position: '区块链交易',
  },
  {
    id: 6,
    year: '2020',
    word: '实用新型专利',
    position: '用于大数据',
  },
  {
    id: 7,
    year: '2021',
    word: '实用新型专利',
    position: '自助金融设备',
  },
  {
    id: 8,
    year: '2022',
    word: '软著',
    position: '挚云Devops',
  },
  {
    id: 9,
    year: '2023',
    word: '软著',
    position: '挚云接口服务',
  },
];

export const saleList = [
  {
    num: 1,
    title: '项目启动',
    text: '项目经理、产品经理、UI设计师、开发工程师等发起项目启动会议,组建项目团队',
  },
  {
    num: 2,
    title: '产品设计',
    text: '产品经理进行产品需求调研,输出产品需求规格说明书、制作原型图与客户确认',
  },
  {
    num: 3,
    title: 'UI设计及确认',
    text: '制作视觉效果图与客户确认',
  },
  {
    num: 4,
    title: '架构设计',
    text: '架构师根据产品需求、规划等做项目整体架构、数据库设计等',
  },
  {
    num: 5,
    title: '产品研发',
    text: '根据进度安排进行产品研发,并按要求提交开发进度报告',
  },
  {
    num: 6,
    title: '内部测试',
    text: '公司内部搭建测试环境测试系统BUG',
  },
  {
    num: 7,
    title: '培训',
    text: '面向甲方对系统的使用进行培训',
  },
  {
    num: 8,
    title: '系统联测',
    text: '甲方配合参加测试确认产品实际操作问题',
  },
  {
    num: 9,
    title: '交付验收',
    text: '提供安装包,待客户方确认后完成验收',
  },
  {
    num: 10,
    title: '产品上线',
    text: '完成相应产品发布/上线工作',
  },
];
